import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "./types"

export const IconYoutube = forwardRef<SVGSVGElement, IconProps>(
  function IconYoutube(props, ref) {
    const { className, title, titleId, ...otherProps } = props
    const defaultClasses =
      "w-10 h-10 flex-shrink-0 text-black transition-colors duration-150 ease-in focus:outline-none"
    const classes = mergeClasses(defaultClasses, className)

    return (
      <svg
        ref={ref}
        viewBox="0 0 40 40"
        fill="none"
        focusable="false"
        aria-hidden="true"
        tabIndex={-1}
        className={classes}
        aria-labelledby={titleId}
        {...otherProps}
      >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
          d="M5.92801 4.22097L32.1908 2.72692C34.0655 2.62027 35.6717 4.05359 35.7784 5.92833L37.2724 32.1911C37.3791 34.0658 35.9458 35.6721 34.071 35.7787L7.80827 37.2727C5.93354 37.3794 4.3273 35.9461 4.22065 34.0713L2.72661 7.80859C2.61996 5.93385 4.05328 4.32762 5.92801 4.22097Z"
          stroke="currentColor"
          strokeWidth="1.2"
        />
        <path
          d="M27.1449 18.9601L15.8245 12.8227C15.3981 12.5694 14.9046 12.9474 14.9361 13.5007L15.7059 27.0317C15.7373 27.585 16.2705 27.9046 16.6655 27.6046L27.2167 20.223C27.611 19.9108 27.5713 19.2134 27.1449 18.9601Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
